export class ConcealProductDetails {
    static readonly type = '[UI] ConcealProductDetails';
}

export class RevealProductDetails {
    static readonly type = '[UI] RevealProductDetails';
}
